var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 7.34375C0 6.95422 0.154743 6.58063 0.430187 6.30519C0.705631 6.02975 1.07921 5.875 1.46875 5.875H16.1504C19.2171 5.875 21.9177 7.44167 23.4961 9.81909C24.2993 8.60552 25.391 7.61004 26.6732 6.92174C27.9555 6.23344 29.3884 5.8738 30.8438 5.875H45.5312C45.9208 5.875 46.2944 6.02975 46.5698 6.30519C46.8453 6.58063 47 6.95422 47 7.34375V36.8421C46.9995 37.0357 46.9608 37.2273 46.8862 37.4059C46.8116 37.5845 46.7025 37.7466 46.5652 37.883C46.4279 38.0194 46.265 38.1274 46.0859 38.2008C45.9068 38.2743 45.715 38.3117 45.5215 38.3109L30.4775 38.209C29.6993 38.2035 28.9277 38.3527 28.2076 38.6479C27.4875 38.943 26.8333 39.3783 26.2828 39.9285L24.5399 41.6733C24.4035 41.8098 24.2415 41.9181 24.0633 41.992C23.885 42.0658 23.6939 42.1039 23.501 42.1039C23.308 42.1039 23.117 42.0658 22.9387 41.992C22.7604 41.9181 22.5985 41.8098 22.4621 41.6733L20.6957 39.9089C20.1505 39.363 19.503 38.9299 18.7903 38.6345C18.0776 38.3391 17.3136 38.1872 16.542 38.1875H1.46875C1.07921 38.1875 0.705631 38.0328 0.430187 37.7573C0.154743 37.4819 0 37.1083 0 36.7188L0 7.34375ZM24.9688 37.1731C26.5417 35.9291 28.4917 35.2583 30.4971 35.2715L44.0625 35.3636V8.8125H30.8438C29.2856 8.8125 27.7913 9.43147 26.6895 10.5333C25.5877 11.635 24.9688 13.1294 24.9688 14.6875V37.1731ZM22.0254 14.6816C22.0238 13.1245 21.4042 11.6317 20.3026 10.5312C19.2009 9.43067 17.7075 8.8125 16.1504 8.8125H2.9375V35.25H16.542C18.5356 35.25 20.4705 35.9276 22.0312 37.1692L22.0254 14.6816Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWBook);
export default __webpack_public_path__ + "static/media/w-book.c8960ba5032afb90cfa563624ea7084b.svg";
export { ForwardRef as ReactComponent };